module.exports = __webpack_public_path__ + "img/pettigrew_as_a_human_again.37549b08.jpg";